import { useIntl } from "react-intl"
import { EmptyState } from "../EmptyState";

export const NoData = () => {
    const intl = useIntl();

    return (<EmptyState
        header={intl.formatMessage({ id: "EnergyBarChart.NoData", defaultMessage: "No data" })}
        message={intl.formatMessage({ id: "EnergyBarChart.NoDataDescr", defaultMessage: "No data was found in the selected time period" })}></EmptyState>)
}